import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExtendBookingComponent } from './ExtendBooking.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { ChipModule } from 'primeng/chip';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { GalleriaModule } from 'primeng/galleria';
import { MessagesModule } from 'primeng/messages';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RatingModule } from 'primeng/rating';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RadioButton, RadioButtonModule } from 'primeng/radiobutton';


import { HttpClientModule } from '@angular/common/http';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';


const routes: Routes = [
  { path: '', component: ExtendBookingComponent },
];
@NgModule({
  declarations:[ExtendBookingComponent],
  imports: [
    CommonModule,
       PaginatorModule,
       SharedModule,
       FormsModule,
       DropdownModule,
       TableModule,
       CalendarModule,
       ReactiveFormsModule,
       TagModule,
       ProgressSpinnerModule,
       ButtonModule,
       ToastModule,
       GalleriaModule,
       BreadcrumbModule,
       ChipModule,
       PdfViewerModule,
       CardModule,
       RatingModule,
       AccordionModule,
       ConfirmPopupModule,
       ConfirmDialogModule,
       MessagesModule,
       DialogModule,
       RadioButtonModule,
       InputTextModule,
        RouterModule.forChild(routes)
  ],

 exports: [],
   providers: [MessageService,ConfirmationService],
   schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ExtendBookingModule { }
